import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ApiKeyInterceptor implements HttpInterceptor {
  constructor() {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Product API
    if (request.url.indexOf(environment.products.host) != -1)
      request = request.clone({
        setHeaders: {
          'X-Api-Key': environment.products.accessKey,
        },
      });

    return next.handle(request);
  }
}
